import { useState, useEffect } from 'react';
import { collection, onSnapshot, query, where, limit, type DocumentData } from 'firebase/firestore';
import { db } from '../../../lib/firebase';
import { useTenantStore } from '../../../stores/tenant.store';

export function useCrmContacts() {
  const { currentTenantId } = useTenantStore();
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState<DocumentData[]>([]);

  useEffect(() => {
    if (!currentTenantId) {
      setLoading(false);
      return;
    }
    setLoading(true);

    // Filter soft-deleted records at the Firestore query level for efficiency.
    const q = query(
      collection(db, `tenants/${currentTenantId}/crmContacts`),
      where('deletedAt', '==', null),
      limit(500),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        try {
          const docs = snapshot.docs.map((d) => ({ ...d.data(), id: d.id })) as DocumentData[];
          setContacts(docs);
        } catch (err) {
          console.error('[useCrmContacts] Error processing contacts:', err);
        } finally {
          setLoading(false);
        }
      },
      (err) => {
        console.error('[useCrmContacts] Firestore error:', err);
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [currentTenantId]);

  return { data: { items: contacts }, isLoading: loading };
}
